<template>
  <DashboardCard :border="false" :firstContent="true" class="score-width">
    <template v-slot:content>
      <h4 class="mb-0 font-20px">{{`${$t('widgets.score.title')} ${props.data.date}`}}</h4>
    </template>
    <template v-slot:table>
      <MDBTable borderless class="table-dashboard pt-2">
        <tbody>
          <tr>
            <td>{{$t('widgets.score.total')}}</td>
            <td>{{ props.data.total_points }}</td>
          </tr>
          <tr v-if="props.data.show_blocked_points">
            <td>{{$t('widgets.score.unlockedPoints')}}</td>
            <td>{{ props.data.unlocked_points ?? 0 }}</td>
          </tr>
          <tr v-if="props.data.show_blocked_points">
            <td>{{$t('widgets.score.pendingPoints')}}</td>
            <td>{{ props.data.pending_points ?? 0 }}</td>
          </tr>
          <tr>
            <td>{{$t('widgets.score.credits')}} {{ $t(`global.month.${props.data.month}`)}}</td>
            <td>{{ props.data.credits_in_month }}</td>
          </tr>
          <tr>
            <td>{{$t('widgets.score.deductions')}} {{ $t(`global.month.${props.data.month}`)}}</td>
            <td>{{ props.data.deductions_month }}</td>
          </tr>
        </tbody>
      </MDBTable>
    </template>
  </DashboardCard>
</template>

<script setup>
import DashboardCard from "../User/Wholesaler/DashboardCard.vue";
import { MDBTable } from "mdb-vue-ui-kit";
import {defineProps} from "vue";

const props = defineProps({
  data: { type: Object, required: true },
});
</script>

<style scoped lang="scss">
@import "@/styles/_variables.scss";
@import "@/styles/table_dashboard.scss";

.font-20px{
  font-size: 20px;
}
</style>
